import { useState } from 'react';
import { NJMenu } from '@engie-group/fluid-design-system-react';
import { UMIcon, UMR } from '../../../urbanmap/_components';
import { DENSITY_PALETTE } from './densityLegend';

const swatch = (color: string, size = 16) => <span aria-hidden="true"
  style={{ width: size, height: size, flexShrink: 0, background: color, border: `1px solid ${UMR.border}` }} />;

/** Colour dropdown of the legend editor (palette only: Sans valeur / Boucles colours stay reserved). */
export function DensityColorPicker({ value, onChange, label }: { value: string; onChange: (color: string) => void; label: string }) {
  const [opened, setOpened] = useState(false);
  const current = DENSITY_PALETTE.find((c) => c.color.toLowerCase() === value.toLowerCase());
  return <NJMenu.Root opened={opened} onOpen={setOpened}>
    <NJMenu.Anchor>
      <button type="button" className="um-hover-grey" aria-haspopup="menu" aria-expanded={opened}
        aria-label={`${label} : ${current?.label ?? value}`} title={current?.label ?? value}
        style={{ height: 32, width: 64, flexShrink: 0, boxSizing: 'border-box', display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', gap: 4, padding: '0 4px 0 10px', border: `1px solid ${UMR.borderInput}`,
          borderRadius: 0, background: UMR.white, cursor: 'pointer' }}>
        {swatch(value, 18)}
        <UMIcon name="expand_more" family="icons" size={20} color={UMR.black} />
      </button>
    </NJMenu.Anchor>
    <NJMenu.Dropdown aria-label={label} style={{ minWidth: 170, fontFamily: UMR.font }}>
      {DENSITY_PALETTE.map((c) => <NJMenu.Item key={c.color} label={c.label} role="menuitemradio"
        aria-checked={c.color === value}
        style={{ padding: '4px 12px', width: '100%', textAlign: 'left', fontFamily: UMR.font, fontSize: 14,
          lineHeight: '21px', fontWeight: c.color === value ? 700 : 400 }}
        onClick={() => { setOpened(false); onChange(c.color); }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{swatch(c.color)}{c.label}</span>
      </NJMenu.Item>)}
    </NJMenu.Dropdown>
  </NJMenu.Root>;
}
